
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { required } from 'vuelidate/lib/validators'

@Component({
	name: 'Datepicker',
	validations: {
		modelData: {
			required
		}
	}
})
export default class Datepicker extends Vue {
	@Prop()
	private flightNumber!: string
	private modelData: string = this.flightNumber
}
